import type { AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

/**
 * 通用响应结构
 */
export interface ApiResponse<T = unknown> {
  code: number
  message: string
  data: T
}

/**
 * 分页请求参数
 */
export interface PaginationParams {
  page: number
  pageSize: number
}

/**
 * 分页响应数据
 */
export interface PaginationData<T> {
  list: T[]
  total: number
  page: number
  pageSize: number
}

/**
 * 扩展的请求配置
 */
export interface RequestConfig<D = unknown> extends AxiosRequestConfig<D> {
  /** 是否显示加载状态 */
  showLoading?: boolean
  /** 是否显示错误提示 */
  showError?: boolean
  /** 自定义错误处理 */
  handleError?: boolean
  /** 重试次数 */
  retryCount?: number
  /** 重试延迟(ms) */
  retryDelay?: number
}

/**
 * 请求拦截器
 */
export interface RequestInterceptor {
  onFulfilled?: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>
  onRejected?: (error: unknown) => unknown
}

/**
 * 响应拦截器
 */
export interface ResponseInterceptor<T = unknown> {
  onFulfilled?: (response: AxiosResponse<T>) => AxiosResponse<T> | Promise<AxiosResponse<T>>
  onRejected?: (error: unknown) => unknown
}

/**
 * HTTP 客户端配置
 */
export interface HttpClientConfig {
  baseURL?: string
  timeout?: number
  headers?: Record<string, string>
  requestInterceptors?: RequestInterceptor[]
  responseInterceptors?: ResponseInterceptor[]
}

/**
 * HTTP 方法类型
 */
export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

/**
 * 错误码枚举
 */
/** 订单不存在 */
export const ORDER_NOT_FOUND_CODE = 1001;

export enum ErrorCode {
  SUCCESS = 0,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
  NETWORK_ERROR = -1,
  TIMEOUT = -2,
  UNKNOWN = -999,
}

/**
 * HTTP 错误类型
 */
export interface HttpError {
  code: ErrorCode | number
  message: string
  data?: unknown
}
